import styled from "styled-components";
import { gql, useQuery, useMutation, useLazyQuery } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import ManageAdPlan from "./ManageAdPlan";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import Backdrop from "components/other/Backdrop";
import MessageWindow from "components/other/MessageWindow";

const ModalWrap = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
`;

export default () => {
  const navigate = useNavigate();

  const [confirmCancelForm, setConfirmCancelForm] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [errorWindow, setErrorWindow] = useState(false);
  const [cancelBlock, setCancelBlock] = useState(false);
  const [portalLinkLoading, setPortalLinkLoading] = useState(false);
  const [changePlanForm, setChangePlanForm] = useState(false);

  // Fetch data
  const GET_AD_PLAN_BILLING_DATA = gql`
    query GetAdPlanBillingData {
      adPlanBillingData {
        prices {
          product
          price
        }
        vatRate
        adPlan
        subscription {
          id
          status
          expires
          stripe_card_brand
          stripe_card_ending
          stripe_card_exp_month
          stripe_card_exp_year
        }
      }
    }
  `;

  const { data, error, refetch } = useQuery(GET_AD_PLAN_BILLING_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Fetching ad plan billing data error", error);
    captureException(error);
  }

  const onPlanSelect = (plan) => {
    if (!data) return;

    let openPlan = plan;

    if (plan === 3) {
      if (data.adPlanBillingData.adPlan >= 3)
        openPlan = data.adPlanBillingData.adPlan + 1;
    }

    if (openPlan > 7) openPlan = 6;

    navigate(`/review-ad-plan?plan=${openPlan}`);
  };

  // redirect if doesn't have any subscription
  useEffect(() => {
    if (data) {
      if (!data.adPlanBillingData.subscription) navigate("/advertising-plans");
    }
  }, [data]);

  const toggleCancelForm = () => {
    if (!confirmCancelForm) {
      setCancelBlock(true);
      setTimeout(() => setCancelBlock(false), 3000);
    }

    setConfirmCancelForm((prevState) => !prevState);
  };

  // handle Cancel subscription
  const CANCEL_SUBSCRIPTION = gql`
    mutation CancelSubscription {
      cancelStripeSubscription {
        resultCode
      }
    }
  `;

  const [cancelStripeSubscription] = useMutation(CANCEL_SUBSCRIPTION);

  const onCancelSubsription = async () => {
    try {
      if (cancelLoading) return;

      setCancelLoading(true);

      const result = await cancelStripeSubscription();

      const { resultCode } = result.data.cancelStripeSubscription;
      console.log({ resultCode });

      setCancelLoading(false);

      if (resultCode !== 0) {
        openErrorWindow();
        return;
      }

      refetch();
      //navigate("/advertising-plans");
    } catch (error) {
      captureException(error);
      console.log("onCancelSubsription error", error);
      setCancelLoading(false);
      openErrorWindow();
      return;
    }
  };

  // Error handlig
  const openErrorWindow = () => {
    setErrorWindow(true);
  };

  const handleModalClose = (modal) => {
    if (modal === "error") {
      setErrorWindow(false);
    }
  };

  // handle Open Stripe portal
  const GET_STRIPE_PORTAL_LINK = gql`
    query GetStripePortalLink {
      getStripePortalLink {
        url
      }
    }
  `;

  const [getStripePortalLink] = useLazyQuery(GET_STRIPE_PORTAL_LINK);

  const onEditPaymentMethodClick = async () => {
    if (portalLinkLoading) return;

    setPortalLinkLoading(true);

    // get portal link
    const portalLink = await getStripePortalLink({
      fetchPolicy: "network-only",
    });

    const { loading, error, data } = portalLink;

    setPortalLinkLoading(false);

    if (error) {
      console.log("Get stripe portal link error", error);
      captureException(error);
    }

    if (data && !loading) {
      //console.log("portal link data", data);
      if (data.getStripePortalLink?.url) {
        // console.log(
        //   "data.getStripePortalLink.url",
        //   data.getStripePortalLink.url
        // );
        window.location = data.getStripePortalLink.url;
      }
    }
  };

  // handle Change plan
  const toggleChangePlanForm = () => {
    setChangePlanForm((prevState) => !prevState);
  };

  console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="230px" />
        </LoadingBox>
      )}
      {data && data.adPlanBillingData.subscription && (
        <ManageAdPlan
          data={data}
          onPlanSelect={onPlanSelect}
          toggleCancelForm={toggleCancelForm}
          confirmCancelForm={confirmCancelForm}
          cancelBlock={cancelBlock}
          onCancelSubsription={onCancelSubsription}
          onEditPaymentMethodClick={onEditPaymentMethodClick}
          toggleChangePlanForm={toggleChangePlanForm}
          changePlanForm={changePlanForm}
        />
      )}
      {errorWindow && (
        <ModalWrap>
          <Backdrop
            onClick={handleModalClose}
            parameters="error"
            background="rgba(0, 0, 0, 0.7)"
          />
          <MessageWindow handleModalClose={handleModalClose} type="error" />
        </ModalWrap>
      )}
    </>
  );
};
